var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEyeSlashed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1276 20.6773C26.6449 18.4792 28 16 28 16C28 16 23.6274 8 16 8C14.607 8 13.3225 8.26685 12.1534 8.70307L15.4834 12.0331C15.6525 12.0112 15.8249 12 16 12C18.2091 12 20 13.7909 20 16C20 16.1751 19.9888 16.3475 19.9669 16.5166L24.1276 20.6773Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55282 10.7594C5.60008 13.0725 4 16 4 16C4 16 8.37258 24 16 24C17.7502 24 19.3291 23.5788 20.7231 22.9296L17.5019 19.7085C17.0382 19.8965 16.5312 20 16 20C13.7909 20 12 18.2091 12 16C12 15.4688 12.1035 14.9618 12.2915 14.4981L8.55282 10.7594Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55916 5.90422C6.94968 5.5137 7.58285 5.5137 7.97337 5.90422L25.3364 23.2673C25.727 23.6578 25.727 24.291 25.3364 24.6815C24.9459 25.072 24.3127 25.072 23.9222 24.6815L6.55916 7.31843C6.16863 6.92791 6.16863 6.29475 6.55916 5.90422Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeSlashed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-slashed.a59d3742d7fbe4db7b17ca03e3cd1900.svg";